import React, {useEffect} from 'react'
import ReactModal from "react-modal";
import CircularProgress from '@mui/material/CircularProgress/';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";


function ImageLoaderModal({open, numImagesConvertedFromHeic, numImagesUploaded, numImagesFinishedUploading, onUploadFinish}) {

    function CircularProgressWithLabel(props) {
        return (
            <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                <CircularProgress  {...props} />
                <Box
                    sx={{
                        top: 0,
                        left: 0,
                        bottom: 0,
                        right: 0,
                        position: 'absolute',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Typography
                        variant="caption"
                        component="div"
                        sx={{ color: 'text.secondary' }}
                    >
                        {`${Math.round(props.value)}%`}
                    </Typography>
                </Box>
            </Box>
        );
    }

    useEffect(() => {
        if (numImagesUploaded > 0 && numImagesFinishedUploading > 0) {
            if (numImagesUploaded === numImagesFinishedUploading) {
                onUploadFinish()
            }
        }

    }, [numImagesUploaded, numImagesFinishedUploading])

    const displayText = numImagesConvertedFromHeic !== numImagesUploaded ? `Processing Images...` :
        `Uploading Images...`

    const uploadPercentage = numImagesConvertedFromHeic !== numImagesUploaded ? Math.ceil(100 * numImagesConvertedFromHeic/numImagesUploaded) :Math.ceil(100 * numImagesFinishedUploading/numImagesUploaded)
    console.log(uploadPercentage)
    return (
        <ReactModal isOpen={open} id="image-loader-modal">
            <h3>{displayText}</h3>
            <CircularProgressWithLabel value={uploadPercentage} size={100}/>
        </ReactModal>
    )
}

export default ImageLoaderModal;